<template lang="pug">
.empty-entity-placeholder
  WtTitle.empty-entity-placeholder-title(card-title).mb-4 {{ title }}
  figure.image
    img.has-border-radius-large(:src="image")
    .empty-entity-placeholder-empty-text.is-flex.is-flex-direction-column.is-justify-content-flex-end
      .has-text-white.has-text-weight-bold.is-size-4.has-text-centered.is-flex-grow-1.is-justify-content-center.is-flex-direction-column.is-flex.callout-text
        span( :class="{'text-background':textBackground}" ) {{ callout }}
      WtButton.empty-entity-placeholder-button(
        v-if="!_.isEmpty(to) && !_.isEmpty(buttonText)"
        isRouterLink
        :to="{ name: to }"
        size="small"
      ) {{ buttonText }}
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "EmptyEntityPlaceholder",

  components: { WtTitle, WtButton },

  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    callout: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    textBackground: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
.empty-entity-placeholder
  .empty-entity-placeholder-empty-text
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0
    padding: 1rem
  .text-background
    background: rgba(0,0,0,0.5)
    border-radius: $radius-large
</style>
